import React from 'react';
import { SortableList } from '@tribeplatform/react-ui-kit/SortableList';
import { Toggle } from '@tribeplatform/react-ui-kit/Toggle';
import { useBlock } from '../../hooks/index.js';
export const MainMenuBlockSettings = () => {
    const { block: { props: { items: _items }, }, upsertProp, } = useBlock();
    const items = _items.filter(item => item.spaceSlug !== `default::explore` &&
        item.spaceSlug !== 'explore' &&
        item.page !== 'explore');
    const toggleItem = (index, enabled) => {
        const newItems = items.map((item, idx) => idx === index ? Object.assign(Object.assign({}, item), { enabled }) : item);
        upsertProp('items', newItems);
    };
    const onDragEnd = result => {
        if (!result.destination) {
            return;
        }
        const newItems = SortableList.reorder(items, result.source.index, result.destination.index);
        upsertProp('items', newItems);
    };
    return (React.createElement(SortableList, { id: "main-menu-items", onDragEnd: onDragEnd, items: items.map(it => (Object.assign(Object.assign({}, it), { id: it.label }))), renderItem: (item, index) => (React.createElement(SortableList.Item, { id: item.label },
            React.createElement(SortableList.DefaultView, null,
                React.createElement("p", { className: "flex flex-grow text-content-subdued overflow-hidden" },
                    React.createElement("span", { className: "truncate" }, item.label)),
                React.createElement(Toggle, { checked: item.enabled, onChange: enabled => {
                        toggleItem(index, enabled);
                    } })))) }));
};
//# sourceMappingURL=Settings.js.map